// src/pages/LoginPage.jsx
import React, { useState, useEffect } from "react";
import { fetchLoginUrlAPI } from "../features/auth/authAPI";

function LoginPage() {
  useEffect(() => {
    const login = async () => {
      try {
        const url = await fetchLoginUrlAPI();
        window.location.href = url;
      } catch (error) {}
    };

    login();
  }, []);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#ffffff",
  };

  return (
    <div style={containerStyle}>
      <p>로그인 중...</p>
    </div>
  );
}

export default LoginPage;
